import { shapeIdEnum, TmsComponents } from '../../enums';

import doorImg from '../../assets/images/TMS/door.png';
import aquariumImg from '../../assets/images/TMS/aquarium.png';
import paintingImg from '../../assets/images/TMS/painting.png';
import windowImg from '../../assets/images/TMS/window.png';
import restroomImg from '../../assets/images/TMS/restroom.png';
import kitchenImg from '../../assets/images/TMS/Kitchen.png';

import {
  R1_0DEG,
  R1_45DEG,
  R1_90DEG,
  R1_135DEG,
  R1_180DEG,
  R1_225DEG,
  R1_270DEG,
  R1_315DEG,
  C1_0DEG,
  C1_45DEG,
  C1_90DEG,
  C1_135DEG,
  C1_180DEG,
  C1_225DEG,
  C1_270DEG,
  C1_315DEG,

  R2_1_1_0DEG,
  R2_1_1_45DEG,
  R2_1_1_90DEG,
  R2_1_1_135DEG,
  C2_1_1_0DEG,
  C2_1_1_45DEG,
  C2_1_1_90DEG,
  C2_1_1_135DEG,

  R4_1_1_1_1_0DEG,
  R4_1_1_1_1_45DEG,
  R4_2_2_0DEG,
  R4_2_2_45DEG,
  R4_2_2_90DEG,
  R4_2_2_135DEG,
  C4_0DEG,
  C4_45DEG,

  R6_1_2_1_2_0DEG,
  R6_1_2_1_2_45DEG,
  R6_1_2_1_2_90DEG,
  R6_1_2_1_2_135DEG,
  R6_3_3_0DEG,
  R6_3_3_45DEG,
  R6_3_3_90DEG,
  R6_3_3_135DEG,
  C6_0DEG,

  R8_1_3_1_3_0DEG,
  R8_1_3_1_3_45DEG,
  R8_1_3_1_3_90DEG,
  R8_1_3_1_3_135DEG,
  R8_2_2_2_2_0DEG,
  R8_2_2_2_2_45DEG,
  R8_4_4_0DEG,
  R8_4_4_45DEG,
  R8_4_4_90DEG,
  R8_4_4_135DEG,
  C8_0DEG,

  R10_1_4_1_4_0DEG,
  R10_1_4_1_4_45DEG,
  R10_1_4_1_4_90DEG,
  R10_1_4_1_4_135DEG,
  R10_2_3_2_3_0DEG,
  R10_2_3_2_3_45DEG,
  R10_2_3_2_3_90DEG,
  R10_2_3_2_3_135DEG,
  R10_5_5_0DEG,
  R10_5_5_45DEG,
  R10_5_5_90DEG,
  R10_5_5_135DEG,
  C10_0DEG,
} from '../../assets/images/layout';

export default {
  tableVariant: {
    1: [
      { label: 'R-1-0DEG', value: shapeIdEnum.TABLE_1_RECT_0DEG, icon: R1_0DEG, angle: 0 },
      { label: 'R-1-45DEG', value: shapeIdEnum.TABLE_1_RECT_45DEG, icon: R1_45DEG, angle: 45 },
      { label: 'R-1-90DEG', value: shapeIdEnum.TABLE_1_RECT_90DEG, icon: R1_90DEG, angle: 90 },
      { label: 'R-1-135DEG', value: shapeIdEnum.TABLE_1_RECT_135DEG, icon: R1_135DEG, angle: 135 },
      { label: 'R-1-180DEG', value: shapeIdEnum.TABLE_1_RECT_180DEG, icon: R1_180DEG, angle: 180 },
      { label: 'R-1-225DEG', value: shapeIdEnum.TABLE_1_RECT_225DEG, icon: R1_225DEG, angle: 225 },
      { label: 'R-1-270DEG', value: shapeIdEnum.TABLE_1_RECT_270DEG, icon: R1_270DEG, angle: 270 },
      { label: 'R-1-315DEG', value: shapeIdEnum.TABLE_1_RECT_315DEG, icon: R1_315DEG, angle: 315 },
      { label: 'C-1-0DEG', value: shapeIdEnum.TABLE_1_CIRCLE_0DEG, icon: C1_0DEG, angle: 0 },
      { label: 'C-1-45DEG', value: shapeIdEnum.TABLE_1_CIRCLE_45DEG, icon: C1_45DEG, angle: 45 },
      { label: 'C-1-90DEG', value: shapeIdEnum.TABLE_1_CIRCLE_90DEG, icon: C1_90DEG, angle: 90 },
      { label: 'C-1-135DEG', value: shapeIdEnum.TABLE_1_CIRCLE_135DEG, icon: C1_135DEG, angle: 135 },
      { label: 'C-1-180DEG', value: shapeIdEnum.TABLE_1_CIRCLE_180DEG, icon: C1_180DEG, angle: 180 },
      { label: 'C-1-225-DEG', value: shapeIdEnum.TABLE_1_CIRCLE_225DEG, icon: C1_225DEG, angle: 225 },
      { label: 'C-1-270DEG', value: shapeIdEnum.TABLE_1_CIRCLE_270DEG, icon: C1_270DEG, angle: 270 },
      { label: 'C-1-315DEG', value: shapeIdEnum.TABLE_1_CIRCLE_315DEG, icon: C1_315DEG, angle: 315 },
    ],
    2: [
      { label: 'R-1-1-0DEG', value: shapeIdEnum.TABLE_2_RECT_1_1_0DEG, icon: R2_1_1_0DEG, angle: 0 },
      { label: 'R-1-1-45DEG', value: shapeIdEnum.TABLE_2_RECT_1_1_45DEG, icon: R2_1_1_45DEG, angle: 45 },
      { label: 'R-1-1-90DEG', value: shapeIdEnum.TABLE_2_RECT_1_1_90DEG, icon: R2_1_1_90DEG, angle: 90 },
      { label: 'R-1-1-135DEG', value: shapeIdEnum.TABLE_2_RECT_1_1_135DEG, icon: R2_1_1_135DEG, angle: 135 },
      { label: 'C-1-0DEG', value: shapeIdEnum.TABLE_2_CIRCLE_0DEG, icon: C2_1_1_0DEG, angle: 0 },
      { label: 'C-1-45DEG', value: shapeIdEnum.TABLE_2_CIRCLE_45DEG, icon: C2_1_1_45DEG, angle: 45 },
      { label: 'C-1-90DEG', value: shapeIdEnum.TABLE_2_CIRCLE_90DEG, icon: C2_1_1_90DEG, angle: 90 },
      { label: 'C-1-135DEG', value: shapeIdEnum.TABLE_2_CIRCLE_135DEG, icon: C2_1_1_135DEG, angle: 135 },
    ],
    4: [
      { label: 'R-1-1-1-1-0DEG', value: shapeIdEnum.TABLE_4_RECT_1_1_1_1_0DEG, icon: R4_1_1_1_1_0DEG, angle: 0 },
      { label: 'R-1-1-1-1-45DEG', value: shapeIdEnum.TABLE_4_RECT_1_1_1_1_45DEG, icon: R4_1_1_1_1_45DEG, angle: 45 },
      { label: 'R-2-2-0DEG', value: shapeIdEnum.TABLE_4_RECT_2_2_0DEG, icon: R4_2_2_0DEG, angle: 0 },
      { label: 'R-2-2-45DEG', value: shapeIdEnum.TABLE_4_RECT_2_2_45DEG, icon: R4_2_2_45DEG, angle: 45 },
      { label: 'R-2-2-90DEG', value: shapeIdEnum.TABLE_4_RECT_2_2_90DEG, icon: R4_2_2_90DEG, angle: 90 },
      { label: 'R-2-2-135DEG', value: shapeIdEnum.TABLE_4_RECT_2_2_135DEG, icon: R4_2_2_135DEG, angle: 135 },
      { label: 'C-1-0DEG', value: shapeIdEnum.TABLE_4_CIRCLE_0DEG, icon: C4_0DEG, angle: 0 },
      { label: 'C-1-45DEG', value: shapeIdEnum.TABLE_4_CIRCLE_45DEG, icon: C4_45DEG, angle: 45 },
    ],
    6: [
      { label: 'R-1-2-1-2-0DEG', value: shapeIdEnum.TABLE_6_RECT_1_2_1_2_0DEG, icon: R6_1_2_1_2_0DEG, angle: 0 },
      { label: 'R-1-2-1-2-45DEG', value: shapeIdEnum.TABLE_6_RECT_1_2_1_2_45DEG, icon: R6_1_2_1_2_45DEG, angle: 45 },
      { label: 'R-1-2-1-2-90DEG', value: shapeIdEnum.TABLE_6_RECT_1_2_1_2_90DEG, icon: R6_1_2_1_2_90DEG, angle: 90 },
      { label: 'R-1-2-1-2-135DEG', value: shapeIdEnum.TABLE_6_RECT_1_2_1_2_135DEG, icon: R6_1_2_1_2_135DEG, angle: 135 },
      { label: 'R-3-3-0DEG', value: shapeIdEnum.TABLE_6_RECT_3_3_0DEG, icon: R6_3_3_0DEG, angle: 0 },
      { label: 'R-3-3-45DEG', value: shapeIdEnum.TABLE_6_RECT_3_3_45DEG, icon: R6_3_3_45DEG, angle: 45 },
      { label: 'R-3-3-90DEG', value: shapeIdEnum.TABLE_6_RECT_3_3_90DEG, icon: R6_3_3_90DEG, angle: 90 },
      { label: 'R-3-3-135DEG', value: shapeIdEnum.TABLE_6_RECT_3_3_135DEG, icon: R6_3_3_135DEG, angle: 135 },
      { label: 'C-1', value: shapeIdEnum.TABLE_6_CIRCLE, icon: C6_0DEG, angle: 0 },
    ],
    8: [
      { label: 'R-1-3-1-3-0DEG', value: shapeIdEnum.TABLE_8_RECT_1_3_1_3_0DEG, icon: R8_1_3_1_3_0DEG, angle: 0 },
      { label: 'R-1-3-1-3-45DEG', value: shapeIdEnum.TABLE_8_RECT_1_3_1_3_45DEG, icon: R8_1_3_1_3_45DEG, angle: 45 },
      { label: 'R-1-3-1-3-90DEG', value: shapeIdEnum.TABLE_8_RECT_1_3_1_3_90DEG, icon: R8_1_3_1_3_90DEG, angle: 90 },
      { label: 'R-1-3-1-3-135DEG', value: shapeIdEnum.TABLE_8_RECT_1_3_1_3_135DEG, icon: R8_1_3_1_3_135DEG, angle: 135 },
      { label: 'R-2-2-2-2-0DEG', value: shapeIdEnum.TABLE_8_RECT_2_2_2_2_0DEG, icon: R8_2_2_2_2_0DEG, angle: 0 },
      { label: 'R-2-2-2-2-45DEG', value: shapeIdEnum.TABLE_8_RECT_2_2_2_2_45DEG, icon: R8_2_2_2_2_45DEG, angle: 45 },
      { label: 'R-4-4-0DEG', value: shapeIdEnum.TABLE_8_RECT_4_4_0DEG, icon: R8_4_4_0DEG, angle: 0 },
      { label: 'R-4-4-45DEG', value: shapeIdEnum.TABLE_8_RECT_4_4_45DEG, icon: R8_4_4_45DEG, angle: 45 },
      { label: 'R-4-4-90DEG', value: shapeIdEnum.TABLE_8_RECT_4_4_90DEG, icon: R8_4_4_90DEG, angle: 90 },
      { label: 'R-4-4-135DEG', value: shapeIdEnum.TABLE_8_RECT_4_4_135DEG, icon: R8_4_4_135DEG, angle: 135 },
      { label: 'C-1', value: shapeIdEnum.TABLE_8_CIRCLE, icon: C8_0DEG, angle: 0 },
    ],
    10: [
      { label: 'R-1-4-1-4-0DEG', value: shapeIdEnum.TABLE_10_RECT_1_4_1_4_0DEG, icon: R10_1_4_1_4_0DEG, angle: 0 },
      { label: 'R-1-4-1-4-45DEG', value: shapeIdEnum.TABLE_10_RECT_1_4_1_4_45DEG, icon: R10_1_4_1_4_45DEG, angle: 45 },
      { label: 'R-1-4-1-4-90DEG', value: shapeIdEnum.TABLE_10_RECT_1_4_1_4_90DEG, icon: R10_1_4_1_4_90DEG, angle: 90 },
      { label: 'R-1-4-1-4-135DEG', value: shapeIdEnum.TABLE_10_RECT_1_4_1_4_135DEG, icon: R10_1_4_1_4_135DEG, angle: 135 },
      { label: 'R-2-3-2-3-0DEG', value: shapeIdEnum.TABLE_10_RECT_2_3_2_3_0DEG, icon: R10_2_3_2_3_0DEG, angle: 0 },
      { label: 'R-2-3-2-3-45DEG', value: shapeIdEnum.TABLE_10_RECT_2_3_2_3_45DEG, icon: R10_2_3_2_3_45DEG, angle: 45 },
      { label: 'R-2-3-2-3-90DEG', value: shapeIdEnum.TABLE_10_RECT_2_3_2_3_90DEG, icon: R10_2_3_2_3_90DEG, angle: 90 },
      { label: 'R-2-3-2-3-135DEG', value: shapeIdEnum.TABLE_10_RECT_2_3_2_3_135DEG, icon: R10_2_3_2_3_135DEG, angle: 135 },
      { label: 'R-5-5-0DEG', value: shapeIdEnum.TABLE_10_RECT_5_5_0DEG, icon: R10_5_5_0DEG, angle: 0 },
      { label: 'R-5-5-45DEG', value: shapeIdEnum.TABLE_10_RECT_5_5_45DEG, icon: R10_5_5_45DEG, angle: 45 },
      { label: 'R-5-5-90DEG', value: shapeIdEnum.TABLE_10_RECT_5_5_90DEG, icon: R10_5_5_90DEG, angle: 90 },
      { label: 'R-5-5-135DEG', value: shapeIdEnum.TABLE_10_RECT_5_5_135DEG, icon: R10_5_5_135DEG, angle: 135 },
      { label: 'C-1', value: shapeIdEnum.TABLE_10_CIRCLE, icon: C10_0DEG, angle: 0 },
    ],
  },
};

const getTools = (
  seatTxt,
  seatsTxt,
  doorTxt,
  windowTxt,
  aquariumTxt,
  paintingTxt,
  restroomTxt,
  kitchenTxt,
) => {
  const seatlabel = seatTxt || 'Seat';
  const seatslabel = seatsTxt || 'Seats';
  return ([
    {
      name: 'Table',
      type: TmsComponents.table,
      icon: 'table_restaurant',
      toolsArray: [
        { name: `1 ${seatlabel}`, type: TmsComponents.table1Seat, seatCapacity: 1 },
        { name: `2 ${seatslabel}`, type: TmsComponents.table2Seat, seatCapacity: 2 },
        { name: `4 ${seatslabel}`, type: TmsComponents.table4Seat, seatCapacity: 4 },
        { name: `6 ${seatslabel}`, type: TmsComponents.table6Seat, seatCapacity: 6 },
        { name: `8 ${seatslabel}`, type: TmsComponents.table8Seat, seatCapacity: 8 },
        { name: `10 ${seatslabel}`, type: TmsComponents.table10Seat, seatCapacity: 10 },
      ],
    },
    {
      name: 'Images',
      type: TmsComponents.staticImages,
      icon: 'calendar_view_month',
      toolsArray: [
        { name: doorTxt || 'Door', type: TmsComponents.door, icon: doorImg, },
        { name: windowTxt || 'Window', type: TmsComponents.window, icon: windowImg, },
        { name: aquariumTxt || 'Aquarium', type: TmsComponents.aquarium, icon: aquariumImg, },
        { name: paintingTxt || 'Painting', type: TmsComponents.painting, icon: paintingImg, },
        { name: restroomTxt || 'Restroom', type: TmsComponents.restroom, icon: restroomImg, },
        { name: kitchenTxt || 'Kitchen', type: TmsComponents.kitchen, icon: kitchenImg, },
      ],
    },
    { name: 'Circle', type: TmsComponents.circle, icon: 'circle', toolsArray: [], },
    { name: 'Rectangle', type: TmsComponents.rectangle, icon: 'rectangle', toolsArray: [], },
    { name: 'Square', type: TmsComponents.square, icon: 'crop_square', toolsArray: [], },
    { name: 'Polygon', type: TmsComponents.polygon, icon: 'polymer', toolsArray: [], },
  ])
};

export { getTools };
